

import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Button from '@/components/Button/index.vue';
import { getAgentByDocument } from '@/services/agent/get-agent-by-document';
import { getBillingAddress } from '@/services/agent/get-billing-addressId';
import agentUpdate from '@/services/agent/agent-update';
import { createAddressUser } from '@/services/user/create-address-user';
import { GetAddressUserParams, getAddressUser } from '@/services/user/get-address-user';
import { StepDataStore } from '@/config/types';
import {
  InputContainer, Input, Container, Title,
} from './styles';

export default Vue.extend({
  components: {
    InputContainer,
    Input,
    Button,
    ValidationObserver,
    ValidationProvider,
    Container,
    Title,
  },
  data() {
    return {
      addressCopy: {},
      addressObject: {} as any,
      Object: {} as any,
      isLoadingChangeAddress: false,
      isDisabled: false,
      userLogged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      address: '',
      zipCode: '',
      number: '',
      neighborhood: '',
      cdAgent: '',
      city: '',
      state: '',
      complement: '',
      objAdress: {} as any,
      erroStatus: false,
    };
  },
  computed: {
    getStepDate(): StepDataStore {
      return this.$store.state.stepsRegisterTerritoryData;
    },
  },
  methods: {
    getAddressRequest() {
      const params: GetAddressUserParams = {
        tokenKey: this.userLogged.company.stKey,
        cdUser: this.userLogged.idUser,
      };
      getAddressUser(params).then((data) => {
        this.getStepDate.address = { ...this.getStepDate.address, ...data };
      });
    },
    async onSubmit() {
      this.isLoadingChangeAddress = true;

      const params: any = {
        ...this.getStepDate.address,
        cep: this.getStepDate.address.zipCode.replace('-', ''),
        tokenKey: this.userLogged.company.stKey,
        cdUser: this.userLogged.idUser.toString(),
      };

      const resp: any = await createAddressUser(params);

      this.isLoadingChangeAddress = false;
      this.isDisabled = true;
      if (resp.hasErrors) {
        this.$toast.error('Erro ao atualizar o endereço', { timeout: 5000 });
        return;
      }

      this.$toast.success('Operação realizada com sucesso!');
    },
    onChangeAddress() {
      this.isDisabled = false;
      this.addressCopy = { ...this.getStepDate.address };
    },
    onCancelChangeAddress() {
      this.isDisabled = true;
      this.getStepDate.address = { ...this.getStepDate.address, ...this.addressCopy };
      this.addressCopy = {};
    },
    async postAgent() {
      const params = {
        tokenKey: this.userLogged.company.stKey,
        cdAgent: this.cdAgent,
        cdUser: this.userLogged.idUser.toString(),
        address: this.addressObject.objectResult.address,
        number: this.addressObject.objectResult.number,
        neighborhood: this.addressObject.objectResult.neighborhood,
        complement: this.addressObject.objectResult.complement,
        city: this.addressObject.objectResult.city,
        state: this.addressObject.objectResult.state,
        zipCode: this.addressObject.objectResult.zipCode,
      };
      await agentUpdate(params);
    },
    async getAgent() {
      const response = await getAgentByDocument(this.userLogged.company.stKey, this.userLogged.stDocument);
      this.cdAgent = response.id;
      this.addressObject = await getBillingAddress(this.userLogged.company.stKey, this.userLogged.idUser);
      this.Object = this.addressObject.objectResult;
    },
    async searchZipCode(valor: string) {
      const cep = valor.replace(/\D/g, '');
      if (cep !== '') {
        const validacep = /^[0-9]{8}$/;
        if (validacep.test(cep)) {
          const requestOptions = {
            method: 'GET',
            redirect: 'follow',
          } as any;
          fetch(`https://viacep.com.br/ws/${cep}/json/`, requestOptions)
            .then((response) => response.json())
            .then((result) => { this.objAdress = result; })
            .catch((error) => console.log('error', error));
          if (this.objAdress.erro) {
            this.erroStatus = this.objAdress.erro;
          } else {
            this.erroStatus = false;
            this.addressObject.objectResult.state = this.objAdress.uf;
            this.addressObject.objectResult.city = this.objAdress.localidade;
            this.addressObject.objectResult.neighborhood = this.objAdress.bairro;
            this.addressObject.objectResult.address = this.objAdress.logradouro;
          }
        }
      }
    },
  },
  created() {
    const loader = this.$loading.show({
      container: this.$refs.formContainer,
    });
    this.getAddressRequest();
    this.getAgent().then(() => {
      loader.hide();
    });
  },
});
